import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupageShipmentList from "./GroupageShipmentList";

const GroupageItemCard = (props) => {
  const { groupage, expanded, onSearchOpen } = props;
  return (
    <Accordion defaultExpanded={expanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography>{groupage.groupageNo}</Typography>
          <Typography variant="body2">{groupage.description}</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <GroupageShipmentList groupage={groupage} onSearchOpen={onSearchOpen} />
      </AccordionDetails>
    </Accordion>
  );
};

export default GroupageItemCard;
